import { render, staticRenderFns } from "./TestRunnerDashboard.vue?vue&type=template&id=157c96d8&scoped=true"
import script from "./TestRunnerDashboard.vue?vue&type=script&lang=js"
export * from "./TestRunnerDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157c96d8",
  null
  
)

export default component.exports